import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AttachmentListComponent } from '../../list/attachment-list/attachment-list.component';

@Component({
  selector: 'sn-attachment-lookup',
  templateUrl: './attachment-lookup.component.html',
  styleUrls: ['./attachment-lookup.component.css']
})
export class AttachmentLookupComponent implements OnInit {
  @Input() view;
  @Input() data;
  @Input() related_type;
  @Input() related_ID;
  @Input() title;

  constructor(
    public activeModal: NgbActiveModal,
    
  ) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/attachment-lookup/attachment-lookup.component.ts